import React, { useState } from 'react';
import { Tooltip } from 'react-tooltip';
import Links from './Links';
import ThemeToggle from './ThemeToggle';
import { publicUrl } from '../utils/publicUrl';

const LOGO_MAIN = publicUrl('images/icons/mrlogo.svg');
const LOGO_OUTLINE = publicUrl('images/icons/mrlogo-outline.svg');

export default function NavBar() {
  const [logoSrc, setLogoSrc] = useState(LOGO_MAIN);

  const handleLogoHover = () => {
    setLogoSrc((prev) => (prev === LOGO_MAIN ? LOGO_OUTLINE : LOGO_MAIN));
  };

  return (
    <header className="nav-bar">
      <a href="#top" className="logo" aria-label="Mahad Rehan — home">
        <img
          src={logoSrc}
          alt=""
          onMouseEnter={handleLogoHover}
          onMouseLeave={handleLogoHover}
        />
      </a>
      <div className="nav-bar__links">
        <Links
          tooltip="View Github"
          link="https://github.com/mahaaad"
          imgUrl="images/icons/blackgithub.svg"
          hoverImg="images/icons/github-green.svg"
        />
        <Links
          tooltip="View Dribbble"
          link="https://dribbble.com/mahadR"
          imgUrl="images/icons/blackdribbble.svg"
          hoverImg="images/icons/dribbble-green.svg"
        />
        <Links
          tooltip="View LinkedIn"
          link="https://www.linkedin.com/in/mahadrehan/"
          imgUrl="images/icons/blacklinkedin.svg"
          hoverImg="images/icons/linkedin-green.svg"
        />
        <Links
          tooltip="Email"
          link="mailto:mahad.rehan@gmail.com"
          imgUrl="images/icons/blackmail.svg"
          hoverImg="images/icons/mail-green.svg"
        />
        <Links
          tooltip="View Resume"
          link={publicUrl('files/Mahad Rehan Resume.pdf')}
          imgUrl="images/icons/blackresume.svg"
          hoverImg="images/icons/resume-green.svg"
        />
        <ThemeToggle />
      </div>
      <Tooltip id="nav-tooltip" className="nav-tooltip-style" opacity={1} />
    </header>
  );
}
